// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IUndergroundForMobileSite {
  /** ID метро **/
  id: number;
  /** Название станции **/
  name: string;
  /** Строящаяся станция **/
  underConstruction: boolean;
  /** HEX код цвета станции метро **/
  lineColor?: TUndergroundForMobileSite_LineColor;
  /** Тип линии метро (МЦК/МЦД) **/
  lineType?: TUndergroundForMobileSite_LineType;
  /** Время до метро **/
  time?: TUndergroundForMobileSite_Time;
  /** Способ передвижения до станции **/
  transportType?: TUndergroundForMobileSite_TransportType;
}

export type TUndergroundForMobileSite_LineColor = null | string;

export type TUndergroundForMobileSite_LineType = null | ELineType;

export enum ELineType {
  /** МЦД-1 **/
  'Mcd1' = 'mcd1',
  /** МЦД-2 **/
  'Mcd2' = 'mcd2',
  /** МЦД-3 **/
  'Mcd3' = 'mcd3',
  /** МЦД-4 **/
  'Mcd4' = 'mcd4',
  /** МЦК **/
  'Mck' = 'mck',
}
export type TUndergroundForMobileSite_Time = null | string;

export type TUndergroundForMobileSite_TransportType = null | ETransportType;

export enum ETransportType {
  /** На транспорте **/
  'Transport' = 'transport',
  /** Пешком **/
  'Walk' = 'walk',
}
